export const upperFirst = (text: string) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
};
export const upperFirst = (text: string) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
};
